export default function Spinner() {
  return (
    <div style={{ textAlign: "center", padding: "40px" }}>
      <div className="spinner-border text-primary" role="status" />
      <div className="mt-2">جارٍ التحميل...</div>
    </div>
  );
}
